import { Divider, Button, Space, Popover, Checkbox, Badge, Tree, Alert, Tooltip } from "antd"
import React, { useState } from "react";
import { LeftOutlined } from '@ant-design/icons';
import { ClockIcon, FilterIcon, PlusIcon, ArrowIcon } from "../../admin/Icons";
import { blue_color, orange_color, red_color, tt_content_filter } from "../../utils/Utils";
import ContentRow from "./ContentRow";
import moment from "moment";
import TrashedContent from "./TrashedContent";
export default function ContentList(props) {

    const { updateContent = () => { }, selected = false, setSelected = () => { }, setOpen = () => { }, menus = [], page = {}, content = [] } = props;

    const [filters, setFilters] = useState({
        hidden: true,
        test: true,
        visible: true,
        visible_scheduled: true,
        scheduled: true,
        expired: true,
    })

    const {
        id = 0,
        name = "",
        type = "",
        parent_id = null,
        visibility = "test",
        new_tab = false,
        can_delete = false,
        order = 3,
        url = "/",
        v1_page_id = null
    } = page;

    const drawFilter = () => {

        const content = (
            <>
                <div><small style={{ "color": "#1890ff" }}>SHOW / HIDE CONTENT</small></div>
                <div className="shim" /><div className="shim" />
                <Space direction="vertical">
                    <Checkbox onChange={(e) => setFilters({ ...filters, "test": e.target.checked })} checked={filters.test}><span style={{ color: orange_color }}>Draft</span></Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "visible": e.target.checked })} checked={filters.visible}>Visible</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "visible_scheduled": e.target.checked })} checked={filters.visible_scheduled}>Visible scheduled <ClockIcon /></Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "scheduled": e.target.checked })} checked={filters.scheduled}><span style={{ color: blue_color }}>Scheduled <ClockIcon style={{ color: blue_color }} /></span></Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "expired": e.target.checked })} checked={filters.expired}><span style={{ color: red_color }}>Expired <ClockIcon style={{ color: red_color }} /></span></Checkbox>
                </Space>
            </>
        );

        return (
            <Popover placement="bottomRight" title={false} content={content} trigger="click">
                <Button size="small" type="text" icon={<Badge color="blue" offset={[2, 5]} dot={(filters.hidden || filters.visible || filters.test)}>
                    <Tooltip title={tt_content_filter}><FilterIcon style={{ "width": "9px", "fill": "#a1a1a1", "margin": "0 auto" }} /></Tooltip>
                </Badge>} />
            </Popover>
        )
    }


    const getScheduled = (start, end) => {
        let ret;
        const now = moment().unix();

        switch (true) {
            // Both Unset - don't draw
            case start === null && end === null:
                return "not_scheduled"
            // One set
            case start === null && end > now:
                ret = "scheduled"; break;
            case start === null && end < now:
                ret = "expired"; break;
            case end === null && start > now:
                ret = "scheduled"; break;
            case end === null && start < now:
                ret = "expired"; break;
            // Both set
            case start < now && end > now:
                ret = "visible_scheduled"; break;
            case start < now && end < now:
                ret = "expired"; break;
            case start > now && end > now:
                ret = "scheduled"; break;
            default:
                ret = "visible_scheduled"; break;
        }

        return ret;

    }


    const getClass = (_item) => {

        if (!filters.hidden && _item.visibility === "hidden") {
            return "hide-content";
        }

        if (!filters.test && _item.visibility === "test") {
            return "hide-content";
        }

        if (!filters.visible && _item.visibility === "visible") {
            return "hide-content";
        }

        let scheduled = getScheduled(_item.start_date, _item.end_date);

        if (!filters.visible_scheduled && scheduled === "visible_scheduled") {
            return "hide-content";
        }

        if (!filters.scheduled && scheduled === "scheduled") {
            return "hide-content";
        }

        if (!filters.expired && scheduled === "expired") {
            return "hide-content";
        }

        return "";
    }
    const filterFilters = (_arr) => {



        let ret = [..._arr];

        if (!filters.hidden) {
            ret = ret.filter(i => i.visibility !== "hidden")
        }

        return ret;

        if (!filters.test) {
            ret = ret.filter(i => i.visibility === "test")
        }

        if (!filters.visible) {
            ret = ret.filter(i => i.visibility === "visible")
        }




    }




    const moveItemById = (arr, id, newIndex) => {
        const oldIndex = arr.findIndex(item => item.id === id);
        if (oldIndex === -1) {
            console.error(`Item with id ${id} not found`);
            return arr;
        }
        const item = arr[oldIndex];
        arr.splice(oldIndex, 1);
        arr.splice(newIndex, 0, item);
        return arr;
    }

    const onDrop = (info) => {

        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        let c = [...content];
        let dgki = c.findIndex(i => i.id === dragKey);
        let dpki = c.findIndex(i => i.id === dropKey);

        // this is garbage logic because it's unclear how this component actually produces values. 
        let dp = 0;
        if (dgki > dpki) {
            dp = parseInt(dropPos[1]) + 1;
            if (dropPosition === -1) {
                dp = 0;
            }
        } else {
            dp = dropPos[1]
        }

        let x = moveItemById(c, dragKey, Math.max(0, dp))
        updateContent(x);
    };

    const drawItem = (_item) => {
        return (<ContentRow page={page} page_content={content} updateContent={updateContent} selected={selected} setSelected={setSelected} content={_item} />)
    }

    const nav = content.map(item => {
        return {
            title: drawItem(item),
            key: item.id,
            className: getClass(item),
            // HIDE GLOBALS
            style: { display: (item.component === "nav_bar" || item.component === "search_bar" || item.component === "footer_bar") ? "none" : "inherit" }
        }
    })

    const drawItems = () => {
        return (
            <Tree
                allowDrop={(a) => {
                    return (a.dropPosition !== 0) ? true : false
                }}
                className="content-tree"
                style={{ "marginLeft": "-5px" }}
                draggable
                blockNode
                onSelect={(_selectedKeys, _node) => {

                }}
                onDrop={(e) => onDrop(e)}
                selectedKeys={[]}
                treeData={nav}
            />
        )
    }

    return (
        <div style={{ "padding": "15px", "paddingTop": "0px" }}>
          
            <div className="float-flex">
            


                <div onClick={() => setOpen(false)} style={{ "fontSize": "16px", "cursor": "pointer" }}>
                    <Space>
                        <Button size="small" type="text" icon={<strong>←</strong>} />
                        <strong>{name}</strong>
                    </Space>
                </div>
                <div>
                    <Space>
                        {drawFilter()}
                    </Space>
                </div>
            </div>
            <div className="shim" /><div className="shim" />
            <Alert type="info" closable message={<small>Click and drag to change the order of content.</small>} />
            {/* <Divider style={{ "margin": "10px 0px" }} />
            <div className="float-flex" style={{ "padding": "0px 0px" }}>
                <Button type="link" icon={<PlusIcon />} size="small" ><small>&nbsp; Add new content</small></Button>
            </div> */}
            <Divider style={{ "margin": "10px 0px" }} />
            {drawItems()}
            <TrashedContent page={name} content={content} updateContent={updateContent} menus={menus} />

            {/* <Divider style={{ "margin": "15px 0px" }} /> */}
        </div>
    )
}